/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type DeleteTeamInput = {
    id: string;
    csrfToken?: string | null | undefined;
    socketClientId?: string | null | undefined;
    clientMutationId?: string | null | undefined;
};
export type deleteTeamMutationVariables = {
    input: DeleteTeamInput;
};
export type deleteTeamMutationResponse = {
    readonly deleteTeam: {
        readonly deletedTeamId: string | null;
    } | null;
};
export type deleteTeamMutation = {
    readonly response: deleteTeamMutationResponse;
    readonly variables: deleteTeamMutationVariables;
};



/*
mutation deleteTeamMutation(
  $input: DeleteTeamInput!
) {
  deleteTeam(input: $input) {
    deletedTeamId
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeleteTeamInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteTeamPayload",
    "kind": "LinkedField",
    "name": "deleteTeam",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedTeamId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "deleteTeamMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "deleteTeamMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "deleteTeamMutation",
    "operationKind": "mutation",
    "text": "mutation deleteTeamMutation(\n  $input: DeleteTeamInput!\n) {\n  deleteTeam(input: $input) {\n    deletedTeamId\n  }\n}\n"
  }
};
})();
(node as any).hash = '67bb6eeff8e7e1b50a18158c63836f8e';
export default node;
